// extracted by mini-css-extract-plugin
module.exports = {"details__wrapper":"groupDetails_details__wrapper__1Z0In","details__list__wrapper":"groupDetails_details__list__wrapper__1eLx8","details__list":"groupDetails_details__list__1DxWb"};